// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"123bc1cf","453":"17d71f68"}[chunkId] + ".chunk.js";
};